import preval from 'preval.macro';

// The time this app was built. Can be used for cache-busting for example.
export const buildTime = preval`module.exports = Date.now()`;
